export const UniversityInfo = ({ universityData }) => {
  return (
    <div className="font-altis grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-4 mb-8 p-4 rounded-lg">
      {/* University (3/12 = 25%) */}
      <div className="bg-[#FFFCE0] border border-[#F2ECBD] rounded-lg p-1 lg:col-span-3">
        <div className="flex justify-between items-center">
          <div className="font-altis text-[16px] font-bold text-[#161719] mb-1">University</div>
          <img
            src={`https://flagcdn.com/24x18/${universityData.flag?.toLowerCase() || "us"}.png`}
            alt={`${universityData.countryName || "Unknown"} flag`}
            className="w-6 h-4"
          />
        </div>
        <span className="font-normal text-[16px] text-[#572575]">{universityData.name}</span>
      </div>

      {/* Course Details (5/12 = wider) */}
      <div className="bg-[#FFFCE0] border border-[#F2ECBD] rounded-lg p-1 lg:col-span-4">
        <div className="flex justify-between items-center">
          <div className="font-altis text-[16px] font-bold text-[#161719] mb-1">Course Details:</div>
          <span className="font-altis text-[16px] text-[#572575] mr-2">{universityData.duration}</span>
        </div>
        <span className="font-altis text-[16px] text-[#572575]">{universityData.courseName}</span>
      </div>

      {/* Annual Tuition Fees (2/12 = narrow) */}
      <div className="bg-[#FFFCE0] border border-[#F2ECBD] rounded-lg p-1 lg:col-span-3">
        <div className="font-altis text-[16px] font-bold text-[#161719] mb-1">Annual Tuition Fees</div>
        <div className="font-altis text-[16px] text-[#572575]">{universityData.annualFees}</div>
      </div>

      {/* Total Tuition Fees (2/12 = narrow) */}
      <div className="bg-[#FFFCE0] border border-[#F2ECBD] rounded-lg p-1 lg:col-span-2">
        <div className="font-altis text-[16px] font-bold text-[#161719] mb-1">Total Tuition Fees</div>
        <div className="font-altis text-[16px] text-[#572575]">{universityData.totalFees}</div>
      </div>
    </div>
  )
}
